import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatSnackBar, MatDialog } from '@angular/material';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { BusquedaXNombreComponent } from 'app/modals/cartera/busqueda-x-nombre/busqueda-x-nombre.component';
import { TipoFacturaComponent } from 'app/modals/cartera/tipo-factura/tipo-factura.component';
import { DebitoAutoComponent } from 'app/modals/cartera/debito-auto/debito-auto.component';
import { AddCobroFijoComponent } from 'app/modals/cartera/add-cobro-fijo/add-cobro-fijo.component';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { ObservacionCarteraGrupoComponent } from 'app/modals/cartera/observacion-cartera-grupo/observacion-cartera-grupo.component';
import { Title } from '@angular/platform-browser';
import { BeneficiariosXGrupoComponent } from 'app/modals/cartera/beneficiarios-x-grupo/beneficiarios-x-grupo.component';

@Component({
  selector: 'app-programar-cobros-fijo',
  templateUrl: './programar-cobros-fijo.component.html',
  styleUrls: ['./programar-cobros-fijo.component.scss']
})
export class ProgramarCobrosFijoComponent implements OnInit, AfterViewInit, OnDestroy {

  // Variables DataTable 
  public dtOptions;
  public tableOpt = [];
  @ViewChild(DataTableDirective , {static: true}) tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  public documento: string;
  public radicado: string;
  private search_code: string;
  public isNull_grupo: boolean = false;
  public index_selected: number = 1;
  public selected_toogleGroup: string = '0';
  public empresa: {
    nombre: string,
    base_datos: string,
    indice: string,
    tp_contrato?: string
  }
  private array_radicados: Array<string> = [];

  /**
   * Constructor
   * 
   * @param {MatSnackBar} _snackBar 
   * @param {CarteraService} _cartera 
   * @param {MatDialog} _dialog 
   * @param {Title} _title 
   */
  constructor
  (
    private _snackBar: MatSnackBar, 
    private _cartera: CarteraService,
    private _dialog: MatDialog,
    private _title: Title
  ) 
  {
    this._title.setTitle('VitalSoft - Agregar a Cobros Fijos')

    this.empresa = {
      nombre: 'Red Médica Vital',
      base_datos: 'medisoft',
      indice: '1'
    }

    this.dtTrigger = new Subject();
    this.dtTrigger.next();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this.dtOptions = {
      responsive: true,
      language: {
        lengthMenu: `Número de _MENU_ registros por página`,
        zeroRecords: `Datos no encontrados - Lo sentimos`,
        info: `Mostrando la página _PAGE_ de _PAGES_`,
        infoEmpty: `No hay registros disponibles`,
        infoFiltered: `(Filtrado de _MAX_ registros totales)`,
        LoadingRecords: `Cargando...`,
        search: `Buscar:`,
        paginate: {
          first:   `Primero`,
          last:    `Último`,
          next:    `Siguiente`,
          previous:`Anterior`
        }
      },
      columns: [
        {},
        {
          data: 'nombre_grupo'
        },
        {
          data: 'codigo_grupo'
        },
        {
          render: (data, type, row, meta) => {
            return `<a style="color: ${data !== '0' ? '#000000' : '#FFFFFF'}">${data}</a>`;
          }
        },
        {
          data: 'ciclo_grupo'
        },
        {},
        {
          render: (data, row, type, meta) => {
            return  `<a>${data}</a>`;
          }
        },
        /* {
          render: (data, row, type, meta) => {
            return `<a>${data}</a>`;
          }
        }, */
        {
          data: 'cobro_periodo'
        },
        {
          data: 'CobroPeriodoDia'
        },
        {
          data: 'cobroPeriodo_estado'
        },
        {
          data: 'CobroPeriodoLLaConf'
        }
      ]
    }
    this.radicadosxEmpresa(this.empresa.base_datos);
  }

  /**
   * After View Init
   */
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Función encargada de asignar valores a la variable empresa, dependiendo de la variable opción
   * ejecuta 'radicadosxEmpresa'
   * @param {string} opcion 
   */
  public seleccionBD(opcion: string): void {

    this.selected_toogleGroup = opcion;

    this.empresa = {
      nombre: opcion === '1' ? 'VitalMascotas' : 'Red Médica Vital',
      base_datos: opcion === '0' ? 'medisoft' : 'medisoftvet',
      indice: opcion === '0' ? '1' : '2'
    }

    this.radicadosxEmpresa(this.empresa.base_datos);
  }

  /**
   * Función que vuelve las variables documento y radicado undefined, para que no produzca
   * errores a la hora de ejecutar la búsqueda
   */
  public clicTab(){
    this.documento = undefined;
    this.radicado = undefined;
  }

  /**
   * Función donde se realizan filtros antes de buscar el grupo, si uno de estos filtros se 
   * cumple, realiza un return, de lo contrario, ejecuta 'mostrarInfoGrupo'
   */
  public validacionBusqueda(documento: string, radicado: string): void {
    const regExr = /[^A-Za-z0-9]/g;

    // Condición: Si la variable documento cumple con la expresión regular, realiza un return; //
    if(regExr.test(documento) || regExr.test(radicado)){
      this._snackBar.open('Error: Datos Inválidos', '', {
        panelClass: ['warn-600'],
        duration: 2000
      });
      return;
      // Condición: si las variables documento y radicado estan vacias, realiza un return; //
    }else if(!documento && !radicado){
      this._snackBar.open('Error: Campo Requerido', '', {
        panelClass: ['warn-600'],
        duration: 2500
      });
      return;
    }

    // Si ninguna de las condiciones se cumple se ejecuta esta función //
    this.busquedaInfoGrupo(documento, radicado);
  }

  /**
   * Realiza la búsqueda de Radicados
   * @param {string} database 
   */
  public radicadosxEmpresa(database: string): void{
    // Se vacia el arreglo array_radicados //
    this.array_radicados.splice(0, this.array_radicados.length);

    this._cartera.VerRadicados(database).subscribe((data: Array<{radicado: string}>) => {
      // se llena el arreglo array_radicados //
      data.forEach(element => {
        this.array_radicados.push(element.radicado);
      });
    });
  }

  /**
   * Cambia el valor de la variable radicado dependiendo de la opción, ejecuta 'mostrarInfoGrupo'
   * @param {string} opcion 
   */
  public changeRadicado(opcion: string): void{
    const Position: number = this.array_radicados.indexOf(this.radicado);
    switch (opcion) {
      case 'first':
        this.radicado = this.array_radicados[0];
        this.busquedaInfoGrupo(this.documento, this.radicado);
        break;
      case 'before':
        this.radicado = this.array_radicados[Position - 1];
        this.busquedaInfoGrupo(this.documento, this.radicado);
        break;
      case 'next':
        this.radicado = this.array_radicados[Position + 1];
        this.busquedaInfoGrupo(this.documento, this.radicado);
        break;
      case 'last':
        this.radicado = this.array_radicados[this.array_radicados.length - 1];
        this.busquedaInfoGrupo(this.documento, this.radicado);
        break;
    }
  }

  /**
   * Muestra la información del grupo consultado
   */
  busquedaInfoGrupo(documento: string, radicado: string): void {
    this._cartera.VerInfoGrupo(radicado, documento, this.empresa.base_datos).subscribe((data: any) => {
      if(data.length){
        this.renderer();
        this.tableOpt = data;
        this.search_code = documento ? documento : radicado;
        this.isNull_grupo = false;
        this.empresa.tp_contrato = data[0].tipo_contrato;
      }else{
        this.isNull_grupo = true;
      }
    });
  }

  /**
   * Renderiza la tabla
   */
  renderer(): void{
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    })
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Modals
  // -----------------------------------------------------------------------------------------------------

  /**
   * Abre el modal BusquedaxNombre, encargado de la búsqueda por el nombre del grupo,
   * cuando no se tiene conocimiento del radicado ó del documento, al cerrarse,
   * devuelve un radicado y una empresa
   */
  public busquedaxNombre(): void{
    let modal;
    modal = this._dialog.open(BusquedaXNombreComponent, {
      width: '40vw'
    });
    modal.afterClosed().subscribe((result: any) => {
      this.empresa = {
        nombre: result.empresa === '0'? 'Red Médica Vital' : 'VitalMascotas',
        base_datos: result.empresa === '0'? 'medisoft' : 'medisoftvet',
        indice: result.empresa === '0'? '1' : '2'
      }
      this.selected_toogleGroup = result.empresa;
      this.index_selected = 1;
      this.radicado = result.radicado;
    });
  }

  /**
   * Abre modal TipoFactura, encargado de la visualización y la modificación del tipo de factura del 
   * grupo en cuestión, al cerrarse, si devuelve una variable verdadera, ejecuta 'mostrarInfoGrupo'
   */
  public modalTipoFactura(): void{
    let modal: any;
    modal = this._dialog.open(TipoFacturaComponent, {
      width: `26%`,
      data: {
        empresa: this.empresa.base_datos,
        codigo: this.search_code,
        factura_fis: this.tableOpt[0]['factura_fisica'],
        factura_elec: this.tableOpt[0]['factura_elec']
      }
    });
    modal.afterClosed().subscribe((result: any) => {
      // Condición: si result es verdadero, ejecuta 'busquedaInfoGrupo' //
      if(result) this.busquedaInfoGrupo(this.documento, this.radicado);
    });
  }

  /**
   * Abre modal AddCobroFijo, encargado de añadir al grupo la fecha de cobro y si se llama a recordar,
   * al cerrarse, sí devuelce una variable verdadera(TRUE), ejecuta 'busquedaInfoGrupo'
   */
  public modalAgregarCobroFijo(): void{
    let modal: any;
    modal = this._dialog.open(AddCobroFijoComponent, {
      width: '38%',
      data: {
        database: this.empresa.base_datos,
        grugru: this.tableOpt[0]['radicado_grupo'],
        grunit: this.tableOpt[0]['codigo_grupo']
      }
    });

    modal.afterClosed().subscribe((result: boolean) => {
      // Condición: si result es verdadero, ejecuta 'busquedaInfoGrupo' //
      if(result) this.busquedaInfoGrupo(this.documento, this.radicado);
    });
  }

  /**
   * Abre modal FuseConfirmDialog, encargado de mostrar una mensaje de confirmación, si el usuario acepta, 
   * devuelve una variable verdadera(TRUE), y se ejecuta el servicio 'QuitarCobroFijo'
   */
  public quitarCobroFijo(): void {
    let modal: any;
    let datos = {
      grunit: this.tableOpt[0]['codigo_grupo'],
      grugru: this.tableOpt[0]['radicado_grupo'],
      database: this.empresa.base_datos,
      user: JSON.parse(localStorage.getItem('usuario'))['id_usuario']
    }

    modal = this._dialog.open(FuseConfirmDialogComponent, {
      data: {
        mensaje: '¿Seguro que quiere llevar esa acción?'
      }
    });
    modal.afterClosed().subscribe((result: boolean) => {
      if(result){
        this._cartera.QuitarCobroFijo(datos.database, datos.grunit, datos.grugru, datos.user).subscribe((data: any) => {
          if(data.changedRows == 1){
            this._snackBar.open('Cobro Fijo Eliminado', 'Aceptar', {
              duration: 2000
            });
            this.busquedaInfoGrupo(this.documento, this.radicado);
          }else{
            this._snackBar.open('Error al eliminar el cobro fijo', '', {
              duration: 2000,
              panelClass: ['warn-600']
            });
          }
        });
      } 
    });
  }

  /**
   * Abre modal ObservacionCarteraGrupo, encargado de la visualización y modificación de las observaciones del grupo
   * @param {string} grunit 
   * @param {string} grugru 
   */
  public modalObservacionCartera(grunit: string, grugru: string){
    this._dialog.open(ObservacionCarteraGrupoComponent, {
      width: '30%',
      height: '70%',
      data: {
        grunit: grunit,
        grugru: grugru,
        base_datos: this.empresa.base_datos
      }
    });
  }

  /**
   * Abre modal Beneficiarios, encargado de mostrar el historial de beneficiarios 
   * @param {string} grunit 
   * @param {string} grugru 
   */
  public modalBeneficiarios(grunit: string, grugru: string){
    this._dialog.open(BeneficiariosXGrupoComponent, {
      maxWidth: '93vw',
      data: {
        Documento: grunit,
        Radicado: grugru
      }
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Disabled Functions: Funciones obsoletas con la nueva versión
  // -----------------------------------------------------------------------------------------------------

  /* public modalDebitoAuto(): void {
    let modal: any;
    modal = this._dialog.open(DebitoAutoComponent, {
      width: `26%`,
      data: {
        empresa: this.empresa.base_datos,
        codigo: this.search_code,
        debitoAuto: this.tableOpt[0]['Debito_automatico'],
      }
    });
    modal.afterClosed().subscribe((result:any) => {
      if(result) this.busquedaInfoGrupo(this.documento, this.radicado);
    });
  } */
}
